import React, { FC, SyntheticEvent } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import { GearFilledIcon } from '@adsk/alloy-react-icon';

type TableConfigurationButtonProps = StylableComponent<HTMLDivElement> & {
  onClick?: (e: SyntheticEvent) => void;
};

const TableConfigurationButton: FC<TableConfigurationButtonProps> = ({
  onClick,
  style,
}) => (
  <Button
    onClick={onClick}
    data-testid={'TableConfigurationButton'}
    variant={Button.VARIANTS.TERTIARY}
    size={Button.SIZES.SMALL}
    style={[
      {
        color: 'inherit',
        padding: 0,
      },
      style,
    ]}
  >
    <GearFilledIcon size={20} />
  </Button>
);

TableConfigurationButton.propTypes = {
  onClick: PropTypes.func,
  style: stylePropType,
};

export default TableConfigurationButton;
